import { Link, useLocation } from "react-router-dom";
import { Calendar, FileText, Target, Home } from "lucide-react";

export function Navbar() {
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Inici", icon: Home },
    { path: "/escrits", label: "Escrits", icon: FileText },
    { path: "/horari", label: "Horari", icon: Calendar },
    { path: "/objectius", label: "Objectius", icon: Target },
  ];

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Title */}
          <Link to="/" className="flex items-center space-x-2 group">
            <span className="text-white font-semibold text-xl">
              2026
            </span>
          </Link>

          {/* Navigation Links */}
          <div className="flex items-center space-x-1 sm:space-x-2">
            {navItems.map(({ path, label, icon: Icon }) => (
              <Link
                key={path}
                to={path}
                className={`
                  flex items-center space-x-2 px-3 sm:px-4 py-2 rounded-lg
                  transition-all duration-200 group
                  ${
                    isActive(path)
                      ? "bg-white/10 text-white"
                      : "text-gray-400 hover:text-white hover:bg-white/5"
                  }
                `}
              >
                <Icon
                  className={`w-4 h-4 ${
                    isActive(path)
                      ? "text-blue-400"
                      : "text-gray-400 group-hover:text-white"
                  }`}
                />
                <span className="hidden sm:inline-block font-medium">
                  {label}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}
